import _ from 'lodash';
import {fromJS, Map} from 'immutable';
import {combineReducers} from 'redux-immutable';

import paginatorReducer from '../../paginator/reducer';
import treeReducer from '../tree/reducer';
import Markers from './component';
import mainReducer from './reducer';


export const initialState = {};

const _reducer = combineReducers({
    main: mainReducer,
    paginator: paginatorReducer,
    regionsTreeFilter: treeReducer,
    citiesTreeFilter: treeReducer,
    schoolsTreeFilter: treeReducer,
    userTypesTreeFilter: treeReducer,
    selected: q => q || new Map(),
});
export const reducer = (state, action) => {
    if (!state.get('paginator')) {
        const id = state.get('elementId') || window.uuidv4();
        state = fromJS({
            main: {elementId: id},
        });
    }
    state = _reducer(state, action);
    state = state.set('selected', state.get('paginator').get('selected'));
    return state;
};

export const component = Markers;

window.pgettext('user-type', 'Type-0');
window.pgettext('user-type', 'Type-1');
window.pgettext('user-type', 'Type-2');
window.pgettext('user-type', 'Type-3');
window.pgettext('user-type', 'Type-4');
window.pgettext('user-type', 'Type-5');
window.pgettext('user-type', 'Type-6');
window.pgettext('user-type', 'Type-7');
